module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9533.6167e526.jpg";